import lazyWithRetry from '../utils/lazyWithRetry';
import { PRIVACY_ROUTE, TERMS_ROUTE } from '../legal/legalDocuments';

const Login = lazyWithRetry(() => import('../pages/Login'));
const BidderPortal = lazyWithRetry(() => import('../pages/BidderPortal'));
const ForgotPassword = lazyWithRetry(() => import('../pages/Login/ForgotPassword'));
const ResetPassword = lazyWithRetry(() => import('../pages/Login/ResetPassword'));
const TermsConditions = lazyWithRetry(() => import('../pages/Login/TermsConditions'));
const Privacypolicy = lazyWithRetry(() => import('../pages/Login/Privacypolicy'));
const ForgotPasswordSuccess = lazyWithRetry(() => import('../pages/Login/ForgotPasswordSuccess'));
const ViewScopeDocument = lazyWithRetry(() =>
	import('../pages/ProjectDetails/Components/ViewScopeDocument'),
);
const PublicChangeLog = lazyWithRetry(() =>
	import('../pages/ProjectDetails/Components/PublicChangeLog'),
);
const ChangeLogOverlay = lazyWithRetry(() =>
	import('../pages/ProjectDetails/Components/ChangeLogOverlay'),
);
const ListScopeeDocuments = lazyWithRetry(() =>
	import('../pages/ProjectDetails/Components/ListAllScopeDocuments'),
);
const AuthCallback = lazyWithRetry(() => import('../pages/Login/AuthCallback'));
const AdminConsentCallback = lazyWithRetry(() => import('../pages/Login/AdminConsentCallback'));
const OktaAuthCallback = lazyWithRetry(() => import('../pages/Login/OktaAuthCallback'));
export default [
	{
		exact: true,
		name: 'BidderPortal',
		path: '/bid/:token',
		Component: BidderPortal,
	},
	{
		exact: true,
		name: 'Login',
		path: '/',
		Component: Login,
	},
	{
		exact: true,
		name: 'ForgotPassword',
		path: '/forgotpassword',
		Component: ForgotPassword,
	},
	{
		exact: true,
		name: 'ForgotPasswordSuccess',
		path: '/forgotpasswordsuccess',
		Component: ForgotPasswordSuccess,
	},
	{
		exact: true,
		name: 'ResetPassword',
		path: '/resetpassword',
		Component: ResetPassword,
	},
	{
		exact: true,
		name: 'TermsConditions',
		path: TERMS_ROUTE,
		Component: TermsConditions,
	},
	{
		exact: true,
		name: 'Privacypolicy',
		path: PRIVACY_ROUTE,
		Component: Privacypolicy,
	},
	{
		exact: true,
		name: 'SearchResults',
		path: '/viewScopeDocument',
		Component: ViewScopeDocument,
	},
	{
		exact: true,
		name: 'PublicScopeDocuments',
		path: '/viewScopeDocument/all',
		Component: ListScopeeDocuments,
	},
	{
		exact: true,
		name: 'PublicChangeLog',
		path: '/viewChangeLog/:token',
		Component: PublicChangeLog,
	},
	{
		exact: true,
		name: 'PublicChangeLogOverlay',
		path: '/viewChangeLog/:token/overlay',
		Component: ChangeLogOverlay,
	},
	{
		exact: true,
		name: 'AuthCallback',
		path: '/auth/callback',
		Component: AuthCallback,
	},
	{
		exact: true,
		name: 'AdminConsentCallback',
		path: '/auth/admin-consent/callback',
		Component: AdminConsentCallback,
	},
	{
		exact: true,
		name: 'OktaAuthCallback',
		path: '/auth/callback/okta',
		Component: OktaAuthCallback,
	},
];
